<template >
  <el-image class="pic-cell" :src="item.img" cover @click="onclick"></el-image>
</template>
<script>
export default {
  name: 'pic-cell',
  props: ['item'],
  methods: {
    onclick() {
      window.open(this.item.src)
    },
  },
}
</script>
<style lang="scss" scoped>
.pic-cell {
  display: inline-block;
  padding: 5px 10px;
  width: 540px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/practice/company/pic-cell.vue